import { DeploymentStage, EnvironmentConfig } from "../app/shared/models";

export const environment: EnvironmentConfig = {
  production: false,
  stage: DeploymentStage.DEVELOPMENT,
  ApiAuthentication: true,
  baseApiHost: 'https://dev-console-service.verato-rd.com',
  oktaConfiguration: {
    oidc: {
      issuer: 'https://auth.verato-rd.com/oauth2/default',
      clientId: '0oaf2eye2ahC5VOvs1d7',
      redirectUri: window.location.origin + '/login/callback',
      scopes: ['openid', 'email', 'profile'],
      tokenManager: {
        autoRenew: true,
        storage: 'sessionStorage'
      },
      services: {
        autoRenew: false,
        autoRemove: false,
      },
      cookies: {
        secure: true,
        sameSite: 'lax',
      },
    },
    widget: {
      USE_CLASSIC_ENGINE: false,
    },
  }
};
